import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "common-layout"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("敬请期待……");

const _hoisted_3 = {
  class: "card-header"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "今日待处理工作", -1);

const _hoisted_5 = /*#__PURE__*/_createTextVNode(">>更多");

const _hoisted_6 = {
  class: "text"
};
const _hoisted_7 = {
  class: "operation"
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode("完成");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_main = _resolveComponent("el-main");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_card = _resolveComponent("el-card");

  const _component_el_aside = _resolveComponent("el-aside");

  const _component_el_container = _resolveComponent("el-container");

  const _component_simple_form_dialog = _resolveComponent("simple-form-dialog");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_container, null, {
    default: _withCtx(() => [_createVNode(_component_el_main, null, {
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    }), _createVNode(_component_el_aside, {
      width: "505px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_card, {
        class: "box-card"
      }, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_button, {
          size: "small",
          type: "text",
          onClick: _cache[0] || (_cache[0] = $event => $options.onMoreWsbClick())
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })])]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.todayList, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "item"
          }, [_createElementVNode("div", _hoisted_6, " [" + _toDisplayString(item.plannedStartTime) + "] " + _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
            size: "small",
            type: "text",
            onClick: $event => $options.handleComplete(item)
          }, {
            default: _withCtx(() => [_hoisted_8]),
            _: 2
          }, 1032, ["onClick"])])]);
        }), 128))]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })]), _createVNode(_component_simple_form_dialog, {
    fields: $data.fields,
    onOnModifySubmit: $options.doComplete,
    ref: "formDialog"
  }, null, 8, ["fields", "onOnModifySubmit"])], 64);
}